export default __webpack_public_path__ + "static/media/discover.81194e14.svg";